import { css } from '@emotion/react';
import { semanticTokens, tokens } from '@flysas-tech/commercial-ui';
import { formatCurrency } from 'shared';

import { PriceBreakdown } from './PriceBreakdown';
import { PriceItem } from './types';

const styles = {
  priceContainer: css`
    display: flex;
    justify-content: space-between;
    color: ${semanticTokens.color.text.primary};
    font-size: ${tokens.fontSize.paragraph['paragraph-2']};
  `,
  labelDetails: css`
    font-size: ${tokens.fontSize.paragraph['paragraph-2']};
    margin-left: ${tokens.dimension['space-2']};
  `,
};

type Props = {
  pos: string;
  item: PriceItem;
};

export const CartItem = ({ item, pos }: Props) => {
  return (
    <div css={styles.priceContainer}>
      {item.breakdown ? (
        <PriceBreakdown item={item} pos={pos} />
      ) : (
        <>
          <div>
            <span>
              {item.label} {item.quantity && item.quantity > 1 ? `x ${item.quantity}` : ''}
            </span>
            <span css={styles.labelDetails}>{item.details}</span>
          </div>

          <span css={styles.labelDetails}>
            {typeof item.value === 'string' ? item.value : formatCurrency(item.value, pos)}
          </span>
        </>
      )}
    </div>
  );
};
